import Axios from '../../networking/intraceptor';
import {
  delivery_video_calls,
  delivery_video_calls_auto_pickup_setting,
  patientProfile_ActiveMedicineList,
  patientProfile_AllMedicineList,
  patientProfile_getPatientProfile,
  patientProfile_getPatientMedicineByDin,
  pharmacy_patient_prescriptions_details,
} from '../../networking/urlEndPoints';

export const fetchPortalDeliveryVideoCall = async (callId) => {
  const { data } = await Axios.get(`${delivery_video_calls}/${callId}`);
  return data?.data ?? data;
};

// A recovery-only check used after the browser reconnects or returns from the
// background. It is deliberately not used for polling after ordinary actions.
export const fetchPortalDeliveryVideoCallPending = async () => {
  const { data } = await Axios.get(`${delivery_video_calls}/pending`);
  return data?.data ?? null;
};

export const acceptPortalDeliveryVideoCall = async (callId) => {
  const { data } = await Axios.post(`${delivery_video_calls}/${callId}/accept`, {
    accepted_from: 'pharmacy-portal',
  });
  return data?.data ?? data;
};

export const declinePortalDeliveryVideoCall = async (callId, reason = null) => {
  const payload = reason ? { reason } : {};
  const { data } = await Axios.post(`${delivery_video_calls}/${callId}/decline`, payload);
  return data?.data ?? data;
};

export const endPortalDeliveryVideoCall = async (callId) => {
  const { data } = await Axios.post(`${delivery_video_calls}/${callId}/end`);
  return data?.data ?? data;
};

export const fetchPortalDeliveryVideoCallAutoPickupSetting = async () => {
  const { data } = await Axios.get(delivery_video_calls_auto_pickup_setting);
  return data?.data ?? data;
};

export const enablePortalDeliveryVideoCallAutoPickupSetting = async () => {
  const { data } = await Axios.post(`${delivery_video_calls_auto_pickup_setting}/enable`);
  return data?.data ?? data;
};

export const disablePortalDeliveryVideoCallAutoPickupSetting = async () => {
  const { data } = await Axios.post(`${delivery_video_calls_auto_pickup_setting}/disable`);
  return data?.data ?? data;
};

export const savePortalDeliveryVideoCallImage = async (callId, imageBlob) => {
  const formData = new FormData();
  formData.append('image', imageBlob, `delivery-video-call-${callId}-${Date.now()}.jpg`);

  const { data } = await Axios.post(`${delivery_video_calls}/${callId}/save-image`, formData);
  return data?.data ?? data;
};

export const verifyPortalDeliveryVideoCallPatient = async (callId) => {
  const { data } = await Axios.post(`${delivery_video_calls}/${callId}/verify-patient`);
  return data?.data ?? data;
};

export const savePortalDeliveryVideoCallCounselling = async (callId, payload) => {
  const { data } = await Axios.post(`${delivery_video_calls}/${callId}/save-counselling`, payload);
  return data?.data ?? data;
};

export const signPortalDeliveryVideoCallPrescriptions = async (callId, payload) => {
  const { data } = await Axios.post(`${delivery_video_calls}/${callId}/sign-prescriptions`, payload);
  return data?.data ?? data;
};

export const fetchPortalPatientProfile = async (patientId) => {
  const { data } = await Axios.get(patientProfile_getPatientProfile, {
    params: { id: patientId }
  });
  return data?.data ?? data;
};

export const fetchPortalPatientActiveMedications = async (patientId) => {
  const { data } = await Axios.get(patientProfile_ActiveMedicineList, {
    params: { patient_id: patientId }
  });
  return data?.data ?? data;
};

// Used by the UI-only Active/All tabs in the portal delivery call screen.
export const fetchPortalPatientAllRx = async (patientId, page = 1) => {
  const { data } = await Axios.get(patientProfile_AllMedicineList, {
    params: { page, patient_id: patientId },
  });

  return data?.data ?? data;
};

export const fetchPortalPatientPrescriptionDetails = async (patientId, fromDate) => {
  const { data } = await Axios.get(pharmacy_patient_prescriptions_details, {
    params: { patient_id: patientId, from_date: fromDate },
  });
  return data?.data ?? data;
};

// Triggered from RX card clicks in the portal delivery video-call UI.
// Intentionally returns nothing to the caller; it just performs the request.
export const fetchPatientMedicineByDin = async (din) => {
  const { data } = await Axios.get(patientProfile_getPatientMedicineByDin, { params: { din } });

  return data?.data ?? data;
};
